import { customPalette } from "../../../../theme/theme";

import type { JSX } from "react";

import Grid from "@mui/material/Grid";
import {
  AttributeGroupBehavior,
  AttributeGroupCompletenessIndicator,
  AttributeGroupProps,
  AttributeGroupResetButton,
} from "@plansoft-configuration-renderer/components";
import {
  GroupDebug,
  useShowDebugGroups,
} from "@plansoft-configuration-renderer/debug";

import { CustomAttributeGroupTitle } from "./CustomAttributeGroupTitle";

export function CustomAttributeGroupHeadline(
  props: AttributeGroupProps,
): JSX.Element {
  const isDebug = useShowDebugGroups();

  const {
    showResetButton = false,
    showCompletenessIndicator = false,
    groupBehavior = AttributeGroupBehavior.AllAttributes,
    title,
    titleVariant,
    custom,
  } = props;
  const renderAsCustomPageHeading = custom?.renderAsCustomPageHeading ?? false;

  return (
    <Grid
      container
      columnSpacing={1}
      sx={{
        alignItems: "center",
        borderBottom: renderAsCustomPageHeading
          ? "2px solid " + customPalette.secondary.light
          : "none",
      }}
    >
      <Grid>
        <CustomAttributeGroupTitle
          title={title}
          titleVariant={titleVariant}
          custom={custom}
        />
      </Grid>
      {isDebug && (
        <Grid>
          <GroupDebug id={title} />
        </Grid>
      )}
      {showCompletenessIndicator && (
        <Grid>
          <AttributeGroupCompletenessIndicator
            groupId={title}
            groupBehavior={groupBehavior}
          />
        </Grid>
      )}
      {showResetButton && (
        <Grid>
          <AttributeGroupResetButton
            groupId={title}
            groupBehavior={groupBehavior}
          />
        </Grid>
      )}
    </Grid>
  );
}
